<template>
    <el-container >
      <el-header class="p-0">
        <navbar />
      </el-header>
      <el-container>
        <el-aside>
          <sidebar />
        </el-aside>
        <el-main v-loading="isLoad">
          <child />
        </el-main>
      </el-container>
    </el-container>
</template>

<script>
import Navbar from "@/components/Navbar";
import Sidebar from "@/components/Sidebar";
import Child from "@/components/Child";
// import Preloader from "@/components/Preloader/Preloader";
export default {
  name: "default",
  components: { Child, Sidebar, Navbar },
  async mounted() {  
    if (!this.$store.getters.token) {
      this.$router.push("/login");
    }
    await Promise.allSettled([
      this.$store.dispatch("fetchCurrentUser"),
      this.$store.dispatch("fetchQuentityCalls"),
      this.$store.dispatch("fetchQuentityReviews"),
      this.$store.dispatch("fetchQuentityComments"),      
      this.$store.dispatch("fetchGeneralIcons"),
    ]);
  },
  computed: {
    isLoad() {
      return this.$store.state.Preloader.preloaderState;
    },
  },
};
</script>

<style scoped>
.el-container {
  min-height: 100vh;
}
</style>